import { useContext } from "react";
import { useQuery } from '@tanstack/react-query';
import { IListRolesResponse } from "../../../logic/api";
import { SessionContext } from "../../../utility/useSession";

export const useRoles = () => {
    const { current: session } = useContext(SessionContext);

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<IListRolesResponse | null, Error>({
        queryKey: ['roles', userUuid, tenantId],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error('Session context not available');
            }
            const response = await fetch(`${session.context.url}/rbac/listRoles/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...session.context.headers,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch roles: ${response.statusText}`);
            }
            return response.json();
        },
        enabled: !!userUuid && !!tenantId && !!session?.context,
        staleTime: 5 * 60 * 1000, // 5 min
    });
};